import Vue                  from "vue";
import vSelect from "vue-select";
import { mapGetters }       from "vuex"
import { TmsService }       from "@/services/";
import { LoadingSpinner }   from "@/components";
import DnFunctionButton     from "@/components/Elements/DnFunctionButton.vue";
import { DnRouterLink }     from "@/components/Elements";

export default Vue.extend({
    name: "TruckSelection",
    props: {
        make: {
            type: String,
            default: null
        },
        model: {
            type: String,
            default: null
        },
        category: {
            type: String,
            default: null
        }
    },
    components: {
        LoadingSpinner,
        DnFunctionButton,
        DnRouterLink,
        vSelect
    },
    data:() =>({
        loading: true,
        loadingModels: false,
        loadingCategories: false,
        breadcrumbDivider: "/",
        selectedMake: null,
        selectedModel: "",
        selectedCategory: "",
        makes: [],
        models: [],
        categories: []
    }),
    computed:{
        ...mapGetters(["user", "audienceIds", "activeAccountId"]),
        ModelPlaceholder(){

            if(this.loadingModels){
                return "Loading models..."
            }

            if(this.selectedMake && !this.loadingModels && !this.models.length){
                return "No models found for this make."
            }

            return this.selectedMake?.OemDescription === "CLARK" ? "Select a Lot" : "Select a Model"
        },
        CategoryPlaceholder(){

            if(this.loadingCategories){
                return "Loading categories..."
            }

            if(this.selectedMake && this.selectedModel && !this.loadingCategories && !this.categories.length){
                return "No categories found for this model."
            }

            return "Select a Category"
        }
    },
    created() {   
        this.selectedModel = this.model;
        this.selectedCategory = this.category;

        if(this.make && this.selectedModel && this.selectedCategory){
            this.GoToResultsPage();
        }else{
            this.GetData();
        }
    },
    methods: {
        async GetData(){
            this.loading = true;
            await this.GetMakes();
            
            // If make prop was provided, find the matching object
            if(this.make){
                this.selectedMake = this.makes.find(m => m.OemDescription === this.make);
            }
            
            if(this.selectedMake){
                await this.GetModels();
                this.selectedModel = this.model;

            }
            if(this.selectedMake && this.selectedModel){
                await this.GetCategories();
                this.selectedCategory = this.category;
            }
            this.loading = false;
        },
        async GetMakes(){
            var searchInput = this.CreateSearchInput();
            this.makes = (await TmsService.GetOems(searchInput)).data;
        },
        async GetModels(){
            this.loadingModels = true;
            this.selectedModel = "";
            this.models = [];

            if(this.selectedMake.BrandId > 0){
                // TODO: Make different service call for BrandId > 0
                // Placeholder for now - update with actual service call
            }

            var facets = {
                "OemDescription": this.selectedMake.OemDescription
            };
            var searchInput = this.CreateSearchInput(facets);
            this.models = (await TmsService.GetModels(searchInput)).data;

            this.loadingModels = false;

            if(this.models.length === 1){
                this.selectedModel = this.models[0];
                this.GetCategories();
            }
        },
        async GetCategories(){
            this.loadingCategories = true;
            this.selectedCategory = "";
            this.categories = [];

            var facets = {
                "OemDescription": this.selectedMake.OemDescription,
                "Model": this.selectedModel
            };
            var searchInput = this.CreateSearchInput(facets);     
            this.categories = (await TmsService.GetCategories(searchInput)).data;

            this.loadingCategories = false;
        },
        CreateSearchInput(facets?: object){
            var searchInput = {
                AccountId: this.activeAccountId,
                UserId: this.user.UserId,
                DealerCode: this.user.DealerCode,
                Audiences: this.audienceIds
            }

            if(facets){
                searchInput["Facets"] = facets;
            }

            return searchInput;
        },
        GoToResultsPage(){
            this.$router.push({ name: 'TruckModelSearch', query: {OemDescription: this.selectedMake?.OemDescription || this.make, Model: this.selectedModel, Category: this.selectedCategory}});
        }
    }
});